/**
 * PE-13385: split out of `row-settings-toolbar.component.ts` so consumers
 * that only need the enum (e.g. `ag-grid-theme.ts`, NgRx state) don't drag
 * that standalone component's own imports (`@angular/material/radio`,
 * `/checkbox`, `/icon`, `@angular/forms`, `@ngrx/store`) into their bundle —
 * a component's `imports: [...]` array keeps them referenced, so they
 * don't tree-shake out even when only the enum is actually used.
 */
export enum RowSpacingType {
  large = 'large',
  small = 'small',
  medium = 'medium',
}
